module.exports = __webpack_public_path__ + "img/tips-beginning-icon.6c32656e.svg";